import { render, staticRenderFns } from "./ReportExplanationStatistics.vue?vue&type=template&id=0530c1b0&scoped=true&"
import script from "./ReportExplanationStatistics.vue?vue&type=script&lang=js&"
export * from "./ReportExplanationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ReportExplanationStatistics.vue?vue&type=style&index=0&id=0530c1b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530c1b0",
  null
  
)

export default component.exports